// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { createFileRoute } from "@tanstack/react-router";
import { SecretDetails } from "@/app/secrets/details/details";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId"
)({
  component: SecretDetails,
  loader: ({ params }) => ({
    crumb: `${params.secretId}`,
  }),
});
